import { ADMIN_TYPES } from "services/types";
import { unionBy, uniqBy } from "lodash";

const INITIAL_STATE = {
  getRotoCompanyListingLoading: false,
  addToTemplateLoading: false, // New loading state for template operations
  addToTemplateError: null, // New error state for template operations
  transferredCompanies: new Set(), // Track transferred companies
  rotoCompanyDetails: {
    items: [],
    totalCount: 0,
  },
};

export default function rotoCompanyReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    // Existing listing cases
    case ADMIN_TYPES.ROTO_COMPANY_LISTING_INIT:
      return {
        ...state,
        getRotoCompanyListingLoading: true,
      };

    case ADMIN_TYPES.ROTO_COMPANY_LISTING_SUCCESS:
      return {
        ...state,
        rotoCompanyDetails: {
          items: action.payload.item2,
          totalCount: action.payload.item1,
        },
        getRotoCompanyListingLoading: false,
      };

    case ADMIN_TYPES.ROTO_COMPANY_LISTING_LOAD_MORE_SUCCESS:
      return {
        ...state,
        rotoCompanyDetails: state.rotoCompanyDetails
          ? {
              items: uniqBy(
                state.rotoCompanyDetails?.items.concat(action.payload.item2),
                "id"
              ),
              totalCount: action.payload.item1,
            }
          : {
              items: action.payload.item2,
              totalCount: action.payload.item1,
            },
        getRotoCompanyListingLoading: action.payload ? false : true,
      };

    case ADMIN_TYPES.ROTO_COMPANY_LISTING_FINISH:
      return {
        ...state,
        getRotoCompanyListingLoading: false,
      };

    // New cases for template operations
    case ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE_INIT:
      return {
        ...state,
        addToTemplateLoading: true,
        addToTemplateError: null,
      };

    case ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE_SUCCESS:
      // Add company to transferred set
      const newTransferredCompanies = new Set(state.transferredCompanies);
      newTransferredCompanies.add(action.payload.companyId);

      return {
        ...state,
        addToTemplateLoading: false,
        transferredCompanies: newTransferredCompanies,
        // Update the company in the list to show it's been transferred
        rotoCompanyDetails: {
          ...state.rotoCompanyDetails,
          items: state.rotoCompanyDetails.items.map((company) =>
            company.id === action.payload.companyId
              ? { ...company, isTransferred: true }
              : company
          ),
        },
      };

    case ADMIN_TYPES.ADD_COMPANY_TO_TEMPLATE_FAILURE:
      return {
        ...state,
        addToTemplateLoading: false,
        addToTemplateError: action.payload,
      };

    // Reset transferred companies when changing templates
    case ADMIN_TYPES.RESET_TRANSFERRED_COMPANIES:
      return {
        ...state,
        transferredCompanies: new Set(),
        rotoCompanyDetails: {
          ...state.rotoCompanyDetails,
          items: state.rotoCompanyDetails.items.map((company) => ({
            ...company,
            isTransferred: false,
          })),
        },
      };

    default:
      return state;
  }
}
